<template>
<!-- <div @mousedown.stop.prevent="mouseDown">
    <div class="ql-add-cue" @contextmenu="preventContext($event)" @click="addCue">
        <md-icon>add</md-icon>
        <md-tooltip md-direction="top">Click to add new cue, right click to cancel</md-tooltip>
    </div>
</div> -->
<md-speed-dial class="ql-add-cue" md-open="click" md-direction="bottom">
    <md-button class="md-icon-button md-mini md-clean" md-fab-trigger>
        <md-icon md-icon-morph>close</md-icon>
        <md-icon>add</md-icon>
    </md-button>

    <md-button class="md-fab md-primary md-mini" @click="addCue">
        <md-icon>note_add</md-icon>
        <md-tooltip md-direction="right">Add New Cue</md-tooltip>
    </md-button>

    <md-button class="md-fab md-primary md-mini" @click="addText" v-if="cueToAdd.type=='position'">
        <md-icon>text_fields</md-icon>
        <md-tooltip md-direction="right">Add New Text</md-tooltip>
    </md-button>
    <md-button class="md-fab md-primary md-mini" @click="cancel">
        <md-icon>clear</md-icon>
        <md-tooltip md-direction="right">Cancel</md-tooltip>
    </md-button>
</md-speed-dial>
</template>

<script>
/**
 * Component For...
 */
const ProjectCuesAddCueButton = {
    name: 'projectCuesAddCueButton',
    props: ['cueToAdd'],
    data: function() {
        return {};
    },
    methods: {
        preventContext: function(e) {
            // Doesn't work for some reason.
            e.preventDefault();
            e.stopPropagation();
            return false;
        },
        addCue(e) {
            this.$emit('addCue', e);
        },
        addText(e) {
            this.$emit('addText', e);
        },
        cancel(e) {
            // console.log('here');
            // if (e.button === 2) {
            //     console.log('cancel');
            this.$emit('cancel', e);
            // }
        }
    },
    components: {
    },
    mounted: function() {
        this.$el.addEventListener('contextmenu', (event) => {
            event.preventDefault();
            event.stopPropagation();
            return false;
        });
    }
};

export default ProjectCuesAddCueButton;
</script>

<style lang="scss">
.ql-add-cue {
    z-index: 9999;
}
</style>


// WEBPACK FOOTER //
// add-cue-button.vue?25155c1b